import React from 'react';
import InvestorInvestManageContentSC, {
  TableContentWrapSC,
  TopContentWrapSC,
} from './investor-invest-manage-content.styled';
import { BodyText } from '../typography';
import { FormattedMessage } from 'react-intl';
import dlt from '../../utils/default-lang';
//import Button from '../ui/button';
import { withRouter } from 'react-router-dom';
import InvestorInvestTable from './investor-invest-table';
import InlineLoading from '../ui/inline-loading/inline-loading';

const InvestorInvestManageContent = ({ history, instruction }) => {
  if (Object.keys(instruction).length === 0) {
    return (
      <InvestorInvestManageContentSC>
        <div className="loading-wrap">
          <InlineLoading />
        </div>
      </InvestorInvestManageContentSC>
    );
  }

  return (
    <InvestorInvestManageContentSC>
      <TopContentWrapSC>
        <BodyText className="bolder">
          <FormattedMessage
            id="investor_invest_manage_last_changes"
            defaultMessage={dlt['investor_invest_manage_last_changes']}
          />
        </BodyText>
        {/*   <Button type="LINK" onClick={() => showAllLoanRepayments()}>
  <FormattedMessage id="global_show_all" defaultMessage={dlt['global_show_all']} />
</Button> */}
      </TopContentWrapSC>
      <TableContentWrapSC>
        <InvestorInvestTable instructionHistory={instruction.changes} />
      </TableContentWrapSC>
    </InvestorInvestManageContentSC>
  );
};

export default withRouter(InvestorInvestManageContent);
